var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightOffblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.26999 11.67C1.05999 11.67 0.849986 11.6 0.709986 11.46C0.429986 11.18 0.499986 10.76 0.779986 10.48L5.74999 6.14001L0.779986 1.66001C0.499986 1.38001 0.429986 0.960011 0.709986 0.680011C0.989986 0.400011 1.40999 0.33001 1.68999 0.61001L7.28999 5.51001C7.42999 5.65001 7.49999 5.86001 7.49999 6.07001C7.49999 6.28001 7.42999 6.49001 7.28999 6.63001L1.68999 11.53C1.54999 11.6 1.40999 11.67 1.26999 11.67Z",
    fill: "#505363"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightOffblack);
export default __webpack_public_path__ + "static/media/arrow-right_offblack.b248a87a807b9d5cae4f923a73a81fef.svg";
export { ForwardRef as ReactComponent };